// Cross-browser fullscreen helpers (Chrome, Samsung Internet, Safari desktop).
// iOS Safari does not support element fullscreen; calls fail silently there.
const doc = () => (typeof document === "undefined" ? null : document);

export const isFullscreen = () => {
  const d = doc();
  return !!(d && (d.fullscreenElement || d.webkitFullscreenElement || d.webkitCurrentFullScreenElement));
};

export const enterFullscreen = () => {
  const d = doc();
  if (!d || isFullscreen()) return;
  const el = d.documentElement;
  const req = el.requestFullscreen || el.webkitRequestFullscreen || el.webkitRequestFullScreen || el.msRequestFullscreen;
  if (!req) return;
  try {
    const p = req.call(el, { navigationUI: "hide" });
    if (p && p.catch) p.catch(() => {});
  } catch { /* ignore (e.g. iOS Safari) */ }
};

export const exitFullscreen = () => {
  const d = doc();
  if (!d) return;
  const ex = d.exitFullscreen || d.webkitExitFullscreen || d.webkitCancelFullScreen || d.msExitFullscreen;
  if (!ex) return;
  try { const p = ex.call(d); if (p && p.catch) p.catch(() => {}); } catch { /* ignore */ }
};

export const toggleFullscreen = () => (isFullscreen() ? exitFullscreen() : enterFullscreen());

export const canFullscreen = () => {
  const d = doc();
  const el = d && d.documentElement;
  return !!(el && (el.requestFullscreen || el.webkitRequestFullscreen || el.webkitRequestFullScreen));
};

export const onFullscreenChange = (cb) => {
  const d = doc();
  if (!d) return () => {};
  const h = () => cb(isFullscreen());
  d.addEventListener("fullscreenchange", h);
  d.addEventListener("webkitfullscreenchange", h);
  return () => { d.removeEventListener("fullscreenchange", h); d.removeEventListener("webkitfullscreenchange", h); };
};
